import { useState } from 'react';
import { Button, Col, Form, Row, Spinner, Tab, Tabs } from 'react-bootstrap';
import { ABAS_CLIENTE, paraApi, valoresIniciais } from './camposCliente';
import { buscarEnderecoPorCep } from '../../lib/cep';
import { useToast } from '../../context/ToastContext';

export default function FormCliente({ clienteInicial, aoSalvar }) {
  const toast = useToast();
  const [valores, setValores] = useState(() => valoresIniciais(clienteInicial));
  const [salvando, setSalvando] = useState(false);
  const [buscandoCep, setBuscandoCep] = useState(null);

  function atualizarCampo(nome, valor) {
    setValores((v) => ({ ...v, [nome]: valor }));
  }

  // ViaCEP ao sair do campo de CEP (pedido por Jason 2026-09-19) — só
  // preenche o que veio (nunca apaga um valor já digitado se a busca
  // falhar ou o CEP não existir). `campo.preencheEndereco` vem de
  // camposCliente.js — dois blocos usam isso (endereço pessoal e do
  // trabalho), por isso é genérico por mapa de campos, não hardcoded.
  async function aoSairDoCep(campo) {
    if (!campo.preencheEndereco) return;
    setBuscandoCep(campo.nome);
    const endereco = await buscarEnderecoPorCep(valores[campo.nome]);
    setBuscandoCep(null);
    if (!endereco) return;
    const mapa = campo.preencheEndereco;
    setValores((v) => ({
      ...v,
      [mapa.endereco]: endereco.endereco || v[mapa.endereco],
      [mapa.bairro]: endereco.bairro || v[mapa.bairro],
      [mapa.cidade]: endereco.cidade || v[mapa.cidade],
      [mapa.estado]: endereco.estado || v[mapa.estado],
    }));
  }

  async function aoEnviar(e) {
    e.preventDefault();
    setSalvando(true);
    try {
      await aoSalvar(paraApi(valores));
    } catch (err) {
      toast.erro(err.message || 'Não foi possível salvar');
    } finally {
      setSalvando(false);
    }
  }

  return (
    <Form onSubmit={aoEnviar}>
      <Tabs defaultActiveKey={0} className="mb-3">
        {ABAS_CLIENTE.map((aba, i) => (
          <Tab key={aba.titulo} eventKey={i} title={aba.titulo}>
            <Row className="g-3 pt-2">
              {aba.campos.map((campo) => (
                <Col md={campo.tipo === 'checkbox' || campo.tipo === 'textarea' ? 12 : 6} key={campo.nome}>
                  {campo.tipo === 'checkbox' ? (
                    <Form.Check
                      type="checkbox"
                      id={campo.nome}
                      label={campo.rotulo}
                      checked={valores[campo.nome]}
                      onChange={(e) => atualizarCampo(campo.nome, e.target.checked)}
                    />
                  ) : (
                    <Form.Group controlId={campo.nome}>
                      <Form.Label>
                        {campo.rotulo}
                        {buscandoCep === campo.nome && (
                          <Spinner animation="border" size="sm" className="ms-2" />
                        )}
                      </Form.Label>
                      <Form.Control
                        as={campo.tipo === 'textarea' ? 'textarea' : undefined}
                        rows={campo.tipo === 'textarea' ? 3 : undefined}
                        type={campo.tipo === 'textarea' ? undefined : campo.tipo}
                        value={valores[campo.nome]}
                        required={campo.obrigatorio}
                        onChange={(e) => atualizarCampo(campo.nome, e.target.value)}
                        onBlur={campo.preencheEndereco ? () => aoSairDoCep(campo) : undefined}
                      />
                    </Form.Group>
                  )}
                </Col>
              ))}
            </Row>
          </Tab>
        ))}
      </Tabs>

      <Button type="submit" variant="primary" disabled={salvando}>
        {salvando ? <Spinner animation="border" size="sm" /> : 'Salvar'}
      </Button>
    </Form>
  );
}
